
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    BokkzAlgDataService, BokkzDivDataService,
    Dividendbelasting, DividendTaxEntity, Fonds
} from '@snelstart-ventures/fiscaal/domain-logic';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { combineLatest, Subject, Subscription, takeUntil } from 'rxjs';

@Component({
    selector: 'snelstart-venture-fiscaal-inhoudingsplichtige',
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedUiDetailsModule, SharedUiFormControlsModule],
    templateUrl: './inhoudingsplichtige.component.html',
    styleUrl: './inhoudingsplichtige.component.scss'
})
export class InhoudingsplichtigeComponent implements OnInit, OnDestroy {

    @Input() public id!: string;
    private destroy$ = new Subject<void>();
    public divTaxEntity = {} as DividendTaxEntity;
    public aangifte = {} as Dividendbelasting;
    public inhoudingsplichtigeFg!: FormGroup;
    public focusedElementId: string | null = null;

    constructor(
        public algDataService: BokkzAlgDataService,
        public dataService: BokkzDivDataService,
        private fb: FormBuilder) {
        this.inhoudingsplichtigeFg = this.fb.group({
            rsinInhoudingsplichtige: [''],
            naamInhoudingsplichtige: ['']
        });
    }

    ngOnInit(): void {
      combineLatest([
        this.dataService.dividendTaxEntity,
        this.algDataService.client
      ])
        .pipe(takeUntil(this.destroy$))
        .subscribe(([dividendTaxEntity, client]) => {
          this.divTaxEntity = dividendTaxEntity;
          this.updateForm();

          if (client && !dividendTaxEntity?.aangifte?.inhoudingsplichtige) {
            this.inhoudingsplichtigeFg.patchValue({
              naamInhoudingsplichtige: client.name || '',
              rsinInhoudingsplichtige: client.taxId || ''
            }, { emitEvent: false });

            this.saveForm();
          }
        });
    }

    private updateForm(): void {
        if (!this.divTaxEntity?.aangifte) {
            return;
        }

        this.aangifte = this.divTaxEntity.aangifte;

        // Als er al inhoudingsplichtige data is, gebruik die
        if (this.aangifte.inhoudingsplichtige) {
            this.inhoudingsplichtigeFg.patchValue(this.aangifte.inhoudingsplichtige, { emitEvent: false });
        }
    }

    public saveForm(): void {
        const formValue = this.inhoudingsplichtigeFg.getRawValue();

        // Update de dividendTaxEntity met de form waarden
        this.divTaxEntity = {
            ...this.divTaxEntity,
            aangifte: {
                ...this.divTaxEntity.aangifte,
                inhoudingsplichtige: {
                    naamInhoudingsplichtige: formValue.naamInhoudingsplichtige,
                    rsinInhoudingsplichtige: formValue.rsinInhoudingsplichtige
                }
            } as Dividendbelasting
        };

        // Update in de service
        this.dataService.updateDividendTaxEntity(this.divTaxEntity);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
